<ion-toolbar
  *ngIf="value && options"
  class="custom-accent {{ customClasses.join(' ') }}"
  mode="ios">
  <ion-segment
    class="w-fit"
    [disabled]="disabled"
    [value]="value"
    (ionChange)="valueChange.emit($any($event).detail.value)">
    <ion-segment-button
      *ngFor="let opt of options"
      [value]="opt.value">
      <ion-icon
        *ngIf="opt.icon"
        [name]="opt.icon">
      </ion-icon>
      <ion-label
        *ngIf="opt.label"
        class="switch-label">
        {{ opt.label }}
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</ion-toolbar>
